import React from 'react'
import Measure from 'react-measure'

export default ({
  id,
  x,
  y,
  componentMeasurements,
  mapWidth,
  children,
  active
}) => {
  return (
    <Measure>
      {(markerDimensions) =>
        <div className={`pin-positioner ${active ? 'active' : ''}`} style={{
          left: x * 100 + '%',
          top: y * 100 + '%'
        }}>
          {children(getCalloutLocation({ componentMeasurements, markerDimensions, id }))}
        </div>
      }
    </Measure>
  )
}

function getCalloutLocation ({ componentMeasurements, markerDimensions, id }) {
  const relativeTop = markerDimensions.top - componentMeasurements.top
  const relativeLeft = markerDimensions.left - componentMeasurements.left
  const relativeRight = componentMeasurements.right - markerDimensions.right
  
  if (relativeLeft < -110) return 'right'
  if (relativeRight < -110) return 'left'
  if (relativeTop < 0) return 'down'
  return 'up'
}



// WEBPACK FOOTER //
// ./src/components/pins/pin-positioner.js